import { requestCreator } from "../../common/actions/VisitApi";

/**
 * GET /api/v2/company_values/features
 */

export type CompanyValueFeature = WtdModels.Partial<
  WtdModels.CompanyValueFeature,
  | "feature"
  | "feature_cd"
  | "feature_title"
  | "feature_title_with_break"
  | "feature_category"
  | "feature_color"
  | "feature_help"
>;

export type CompanyValueFeaturesResponse = CompanyValueFeature[];

export const requestToLoadCompanyValueFeatures = requestCreator<undefined, CompanyValueFeaturesResponse, Error>(() => ({
  path: "/api/v2/company_values/features",
  query: {
    fields: "feature,feature_cd,feature_title,feature_title_with_break,feature_category,feature_color,feature_help",
  },
  method: "GET",
}));

/**
 * GET /values
 */

export type CompanyValue = WtdModels.Partial<
  WtdModels.CompanyValue,
  "id" | "rank" | "feature" | "feature_title" | "feature_color" | "feature_cd" | "description"
>;

export type Image = WtdModels.Partial<WtdModels.Image, "id" | "url">;

export type Company = WtdModels.Partial<
  WtdModels.Company,
  "id" | "name" | "company_name" | "mission_statement" | "company_path",
  {
    avatar: Image;
    background: Image;
    visible_company_values: CompanyValue[];
  }
>;

export interface MatchedCompaniesResponse {
  companies: Company[];
  company_value_features: CompanyValueFeature[];
  selected_features: number[];
  total_companies_count: number;
}

export interface SearchCompaniesParams {
  company_id?: string;
  feature_cds: number[];
  occupation_type?: string;
  page?: number;
}

// Find companies by company values
export const requestToSearchCompanies = requestCreator<SearchCompaniesParams, MatchedCompaniesResponse, Error>(
  query => {
    const data: any = {};
    if (query.company_id) {
      data.company_id = query.company_id;
    }
    if (query.feature_cds && query.feature_cds.length) {
      data.feature_cds = query.feature_cds.join();
    }
    if (query.occupation_type) {
      data.occupation_type = query.occupation_type;
    }
    if (query.page) {
      data.page = query.page;
    }
    return {
      path: "/values.json",
      query: data,
      method: "GET",
    };
  }
);



// WEBPACK FOOTER //
// ./frontend/src/company_values/api/index.ts